import React from "react";
import challengeIco from "../../../images/challengeIco.svg";
import clockFire from "../../../images/clockFire.svg";
import rewardStar from "../../../images/rewardStar.svg";
import walletIco from "../../../images/walletIco.svg";
import arrowRight from "../../../images/arrowRight.svg";
import { Modal } from "react-bootstrap";
import numeral from "numeral";

export const PlanCard = ({
  plan,
  deletePost,
  handleShow,
  admin,
  handleShowStart,
}) => {
  function truncateToDecimals(number, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(number * factor) / factor;
  }
  return (
    <>
      <div className="cPlanCard" style={{ transition: "transform linear" }}>
        <main className="flex-1">
          <div className="cardIco mb-4">
            <img src={challengeIco} alt="" />
          </div>
          <h3 className="font-semibold mb-1 text-center">{plan?.name}</h3>
          <div className="liveBadge mb-3">
            {plan.isLive ? "Challenge is Live" : "Challenge is not Live"}
          </div>
          {/* <p className="entryText">${plan.price} Entry Fee</p> */}
          <div className="categM">
            <div className="categMInner">
              <div className="levelCard">
                <div className="icon">
                  <img src={walletIco} alt="" />
                </div>
                <div className="value">
                  <p className="">
                    {numeral(truncateToDecimals(plan.accountBalance, 0)).format(
                      "$0,0"
                    )}{" "}
                    <br />
                    Balance
                  </p>
                </div>
              </div>
              <div className="levelCard">
                <div className="icon">
                  <img src={clockFire} alt="" />
                </div>
                <div className="value">
                  <p className="">
                    {plan.duration.days !== 0
                      ? plan.duration.days + " days"
                      : null}{" "}
                    {plan.duration.hours !== 0
                      ? plan.duration.hours + " hrs"
                      : null}{" "}
                    {plan.duration.minutes !== 0
                      ? plan.duration.minutes + " min"
                      : null}{" "}
                    {plan.duration.seconds !== 0
                      ? plan.duration.seconds + " sec"
                      : null}{" "}
                    <br /> Deadline
                  </p>
                </div>
              </div>
              <div className="levelCard">
                <div className="icon">
                  <img src={challengeIco} alt="" />
                </div>
                <div className="value">
                  <p className="">
                    {numeral(truncateToDecimals(plan.target, 0)).format("$0,0")}{" "}
                    <br />
                    Target
                  </p>
                </div>
              </div>
              <div className="levelCard">
                <div className="icon">
                  <img src={rewardStar} alt="" />
                </div>
                <div className="value">
                  <p className="">
                    {numeral(truncateToDecimals(plan.winReward, 0)).format(
                      "$0,0"
                    )}{" "}
                    <br />
                    Reward
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ul className="text-left mb-5 list-none ">
            {plan.features.map((feature, index) => (
              <li className="" key={index}>
                <span className="arrowImg">
                  <img src={arrowRight} alt="->" />
                </span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </main>
        {admin ? (
          <div className="btnM">
            <button className="themeBtn" onClick={() => handleShow(plan)}>
              Edit
            </button>
            <button className="deleteBtn" onClick={() => deletePost(plan._id)}>
              Delete
            </button>
          </div>
        ) : (
          <div className="btnM" style={{ display: "block" }}>
            <button
              className="themeBtn w-100"
              onClick={() => handleShowStart(plan)}
            >
              Start Challenge
            </button>
          </div>
        )}
      </div>
    </>
  );
};
